// extracted by mini-css-extract-plugin
export default {"studyName":"StudyPopoverRedirect_studyName__t4JU2","popoverText":"StudyPopoverRedirect_popoverText__ZW8cj"};